import { createContext, useContext } from "react";

export interface IComment {
  id: number;
  content: string;
  createdBy?: {
    id: number;
    name: string;
  };
  createdOn: string;
  modifiedOn: string;
  anchor?: IAnchor;
  status: CommentStatusTypes;
};

export const CommentStatuses = {
  added: 'added',
  edited: 'edited',
  deleted: 'deleted',
  none: 'none'
};
export type CommentStatusTypes = typeof CommentStatuses[keyof typeof CommentStatuses];

export interface IAnchor {
  o: number;
  l: number
};

export interface ICommentsContext {
  quillRef: React.RefObject<{ getQuill: () => any | null }>;
  // State
  comments: IComment[];
  selectedCommentId: number | null;
  setSelectedCommentId: (id: number | null) => void;
  // Methods
  showComments: boolean;
  onToggleComments: () => void;
  onAddComment: (content: string, anchor: IAnchor) => void;
  onUpdateComment: (commentId: number, content: string) => void;
  onRemoveComment: (comment: IComment) => void;
  onChangeCommentStatus: (commentId: number, status: CommentStatusTypes) => void;
};

export const CommentsContext = createContext<ICommentsContext | null>(null);

export default function useCommentsContext() {
  const context = useContext(CommentsContext);
  if ( !context ) throw new Error('useCommentsContext must be used within a CommentsProvider');
  return context;
}